(function () {
  function initShowcase(root) {
    var track = root.querySelector('[data-sculpture-track]');
    var prevBtn = root.querySelector('[data-sculpture-prev]');
    var nextBtn = root.querySelector('[data-sculpture-next]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sculpture-slide]'));
    if (!track || slides.length === 0) return;

    var hasLoop = track.getAttribute('data-loop') === 'true' && slides.length > 2;
    var firstRealIndex = hasLoop ? 1 : 0;
    var lastRealIndex = hasLoop ? slides.length - 2 : slides.length - 1;
    var lastIndex = slides.length - 1;

    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
    var autoplayDelay = parseInt(root.getAttribute('data-autoplay-delay'), 10) || 6000;
    var autoplayTimer = null;
    var settleTimer = null;
    var userInteracted = false;

    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap);
      if (isNaN(gap)) gap = parseFloat(getComputedStyle(track).gap);
      if (isNaN(gap)) gap = 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function currentIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var closest = 0;
      var closestDist = Infinity;
      slides.forEach(function (s, i) {
        var sCenter = s.offsetLeft + s.offsetWidth / 2;
        var dist = Math.abs(sCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function scrollToIndex(index, smooth) {
      var target = slides[index];
      if (!target) return;
      var left = target.offsetLeft - (track.clientWidth - target.offsetWidth) / 2;
      if (smooth) {
        track.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        // Force a truly instant jump: the CSS scroll-behavior:smooth on the
        // track can otherwise animate this even when behavior:'auto' is
        // passed, which is what made the loop wrap-around visibly "scroll
        // backwards" instead of being an invisible seamless swap.
        var prevBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = left;
        // restore on next frame, after the instant jump has been applied
        requestAnimationFrame(function () {
          track.style.scrollBehavior = prevBehavior;
        });
      }
    }

    function settleLoop() {
      if (!hasLoop) return;
      var idx = currentIndex();
      if (idx === 0) {
        scrollToIndex(lastRealIndex, false);
      } else if (idx === lastIndex) {
        scrollToIndex(firstRealIndex, false);
      }
    }

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', settleLoop);
    } else {
      track.addEventListener('scroll', function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settleLoop, 80);
      });
    }

    function goNext() {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    }

    function goPrev() {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    }

    function markInteracted() {
      userInteracted = true;
      stopAutoplay();
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { markInteracted(); goNext(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { markInteracted(); goPrev(); });

    function startAutoplay() {
      if (!autoplayEnabled || userInteracted) return;
      stopAutoplay();
      autoplayTimer = setInterval(goNext, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', function () { if (!userInteracted) startAutoplay(); });
    root.addEventListener('touchstart', markInteracted, { passive: true });
    track.addEventListener('wheel', markInteracted, { passive: true });

    // On touch devices, a tap on a link that sits inside a horizontally
    // scrollable/scroll-snap container can get swallowed by the browser's
    // own tap-vs-swipe disambiguation, so the native <a> click never fires.
    // Detect genuine taps (little movement, short duration) ourselves and
    // navigate manually so links work reliably on phones too.
    slides.forEach(function (slide) {
      var href = slide.getAttribute('href');
      if (!href) return;
      var startX = 0;
      var startY = 0;
      var startTime = 0;
      var moved = false;
      slide.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        startX = t.clientX;
        startY = t.clientY;
        startTime = Date.now();
        moved = false;
      }, { passive: true });
      slide.addEventListener('touchmove', function (e) {
        var t = e.changedTouches[0];
        if (Math.abs(t.clientX - startX) > 10 || Math.abs(t.clientY - startY) > 10) {
          moved = true;
        }
      }, { passive: true });
      slide.addEventListener('touchend', function (e) {
        var duration = Date.now() - startTime;
        if (!moved && duration < 500) {
          e.preventDefault();
          window.location.href = href;
        }
      });
    });

    if (hasLoop) {
      scrollToIndex(firstRealIndex, false);
    }

    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-sculpture-showcase]').forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var showcase = event.target.querySelector('[data-sculpture-showcase]');
    if (showcase) initShowcase(showcase);
  });
})();
